import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { skipCurrentTrack } from '../api/client.js';
import { djViewQueryKey } from '../api/queryKeys.js';

import type { ChannelId, DjView, PartySlug } from '@mixwire/contracts';

type SkipVariables = {
  readonly slug: PartySlug;
  readonly channelId: ChannelId;
};

/**
 * The view this resolves with is a poll behind the skip: Spotify answers the write with no body,
 * so what is actually playing now only lands on the next sample.
 */
export const useSkipCurrent = (): UseMutationResult<DjView, Error, SkipVariables> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ slug, channelId }: SkipVariables) => skipCurrentTrack(slug, channelId),
    onSuccess: (djView, { slug, channelId }) => {
      queryClient.setQueryData(djViewQueryKey(slug, channelId), djView);
    },
  });
};
